/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
import { types } from "mobx-state-tree"

/**
 * Typescript enum
 */

export enum PlanningActionsStatus {
  NOT_STARTED="NOT_STARTED",
IN_PROGRESS="IN_PROGRESS",
FINISHED="FINISHED",
FINISHED_WITH_FAILED="FINISHED_WITH_FAILED",
FAILED="FAILED",
UNDO_REQUESTED="UNDO_REQUESTED",
UNDOING="UNDOING",
UNDONE="UNDONE",
UNDO_FAILED="UNDO_FAILED",
PENDING="PENDING"
}

/**
* PlanningActionsStatus
*/
export const PlanningActionsStatusEnumType = types.enumeration("PlanningActionsStatus", [
        "NOT_STARTED",
  "IN_PROGRESS",
  "FINISHED",
  "FINISHED_WITH_FAILED",
  "FAILED",
  "UNDO_REQUESTED",
  "UNDOING",
  "UNDONE",
  "UNDO_FAILED",
  "PENDING",
      ])
